import { api } from '../config'

export const EVENTSBOARD_URL = {
  getEventsProps: (eventName: string) =>
    `${api.withAPI}/admin/analytics/${eventName}/props`,
}
